import { isMobile } from 'react-device-detect';

export abstract class StringUtils {
  public static boxShadowAccount = '0px 4px 4px 0px #00000040';
  public static formatErrorMsg(errorMsg: string) {
    return errorMsg.replaceAll('Firebase: Error (', '').replace(')', '');
  }

  public static formatTime(time: string) {
    const minsLength = Number(time) >= 600 ? -2 : -1;
    const minutes = ("0" + Math.floor((Number(time) / 60) % 60)).slice(minsLength) + ':';
    const seconds = ("0" + Math.floor((Number(time )/ 1) % 60)).slice(-2);

    return minutes + seconds;
  }

  public static formatTimeLabel(time: any) {
    const reps = isMobile ? ' reps' : ' repetitions';
    const secs = isMobile ? ' secs' : ' seconds';
    if (!time) {
      return '5' + reps;
    }
    if (typeof time === 'string') { //repetitions
      return time + reps
    }

    if (time < 61) {
      return time + secs;
    } else {
      const ret =  time / 60;
      return ret <= 1 ? (ret + ' minute') : (ret +' minutes');
    }
  }

  public static repsOrRepetitions() {
    return isMobile ? ' reps' : ' repetitions';
  }

  public static toCamelCase(str: string) {
    if (!str) return '';
    str = str.replaceAll('_', ' ');
    const strArr = str.split(' ');
    let finalStr = '';
    strArr.forEach((s, i) => {
      if (i !== 0) finalStr += ' ';
      finalStr += this.capitalize(s);
    });

    return finalStr;
  }

  public static capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /* function filterByAllProps(query: any, arr: any) {
    return cloneDeep(arr.filter((item: any) => {
      let foundAny: any;
      Object.keys(item).forEach((key: string) => {
        console.log(item[key])
        if (!foundAny) foundAny = item[key].toLowerCase().indexOf(query) > -1;
      });
      return foundAny;
    }))
  } */
}
